import { ILanguage } from "../../interfaces";

export const LanguageEmpty: ILanguage = {
    id: "",
    name: "",  
    abbreviation: "",
  };